import { ResourcefulReducer } from '../../util';
import EventModel from '../models/event_model';

const EventReducer = new ResourcefulReducer('events', EventModel, {
});

export default EventReducer;
